import { Component, input } from '@angular/core';

import { RichParagraphText } from '../../../services/dto/types/rich-text';

@Component({
  selector: 'cam-rich-paragraph-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: true,
})
export class TextComponent {
  text = input.required<RichParagraphText>();
}
